/**
 * ThingsBoard REST API
 * For instructions how to authorize requests please visit <a href=\'http://thingsboard.io/docs/reference/rest-api/\'>REST API documentation page</a>.
 *
 * The version of the OpenAPI document: 2.0
 * Contact: info@thingsboard.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MergedGroupPermissionInfo { 
    entityType?: MergedGroupPermissionInfo.EntityTypeEnum;
    operations?: Array<MergedGroupPermissionInfo.OperationsEnum>;
}
export namespace MergedGroupPermissionInfo {
    export type EntityTypeEnum = 'TENANT' | 'CUSTOMER' | 'USER' | 'DASHBOARD' | 'ASSET' | 'DEVICE' | 'ALARM' | 'ENTITY_GROUP' | 'CONVERTER' | 'INTEGRATION' | 'RULE_CHAIN' | 'RULE_NODE' | 'SCHEDULER_EVENT' | 'BLOB_ENTITY' | 'ENTITY_VIEW' | 'WIDGETS_BUNDLE' | 'WIDGET_TYPE' | 'ROLE' | 'GROUP_PERMISSION';
    export const EntityTypeEnum = {
        TENANT: 'TENANT' as EntityTypeEnum,
        CUSTOMER: 'CUSTOMER' as EntityTypeEnum,
        USER: 'USER' as EntityTypeEnum,
        DASHBOARD: 'DASHBOARD' as EntityTypeEnum,
        ASSET: 'ASSET' as EntityTypeEnum,
        DEVICE: 'DEVICE' as EntityTypeEnum,
        ALARM: 'ALARM' as EntityTypeEnum,
        ENTITYGROUP: 'ENTITY_GROUP' as EntityTypeEnum,
        CONVERTER: 'CONVERTER' as EntityTypeEnum,
        INTEGRATION: 'INTEGRATION' as EntityTypeEnum,
        RULECHAIN: 'RULE_CHAIN' as EntityTypeEnum,
        RULENODE: 'RULE_NODE' as EntityTypeEnum,
        SCHEDULEREVENT: 'SCHEDULER_EVENT' as EntityTypeEnum,
        BLOBENTITY: 'BLOB_ENTITY' as EntityTypeEnum,
        ENTITYVIEW: 'ENTITY_VIEW' as EntityTypeEnum,
        WIDGETSBUNDLE: 'WIDGETS_BUNDLE' as EntityTypeEnum,
        WIDGETTYPE: 'WIDGET_TYPE' as EntityTypeEnum,
        ROLE: 'ROLE' as EntityTypeEnum,
        GROUPPERMISSION: 'GROUP_PERMISSION' as EntityTypeEnum
    };
    export type OperationsEnum = 'ALL' | 'CREATE' | 'READ' | 'WRITE' | 'DELETE' | 'RPC_CALL' | 'READ_CREDENTIALS' | 'WRITE_CREDENTIALS' | 'READ_ATTRIBUTES' | 'WRITE_ATTRIBUTES' | 'READ_TELEMETRY' | 'WRITE_TELEMETRY' | 'ADD_TO_GROUP' | 'REMOVE_FROM_GROUP' | 'CHANGE_OWNER' | 'IMPERSONATE' | 'CLAIM_DEVICES' | 'SHARE_GROUP' | 'ASSIGN_TO_TENANT';
    export const OperationsEnum = {
        ALL: 'ALL' as OperationsEnum,
        CREATE: 'CREATE' as OperationsEnum,
        READ: 'READ' as OperationsEnum,
        WRITE: 'WRITE' as OperationsEnum,
        DELETE: 'DELETE' as OperationsEnum,
        RPCCALL: 'RPC_CALL' as OperationsEnum,
        READCREDENTIALS: 'READ_CREDENTIALS' as OperationsEnum,
        WRITECREDENTIALS: 'WRITE_CREDENTIALS' as OperationsEnum,
        READATTRIBUTES: 'READ_ATTRIBUTES' as OperationsEnum,
        WRITEATTRIBUTES: 'WRITE_ATTRIBUTES' as OperationsEnum,
        READTELEMETRY: 'READ_TELEMETRY' as OperationsEnum,
        WRITETELEMETRY: 'WRITE_TELEMETRY' as OperationsEnum,
        ADDTOGROUP: 'ADD_TO_GROUP' as OperationsEnum,
        REMOVEFROMGROUP: 'REMOVE_FROM_GROUP' as OperationsEnum,
        CHANGEOWNER: 'CHANGE_OWNER' as OperationsEnum,
        IMPERSONATE: 'IMPERSONATE' as OperationsEnum,
        CLAIMDEVICES: 'CLAIM_DEVICES' as OperationsEnum,
        SHAREGROUP: 'SHARE_GROUP' as OperationsEnum,
        ASSIGNTOTENANT: 'ASSIGN_TO_TENANT' as OperationsEnum
    };
}


